import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16.0415 3.95834H3.95817C3.0377 3.95834 2.2915 4.70454 2.2915 5.62501V7.70834C4.58317 8.33334 4.58317 11.6667 2.2915 12.2917V14.375C2.2915 15.2955 3.0377 16.0417 3.95817 16.0417H16.0415C16.962 16.0417 17.7082 15.2955 17.7082 14.375V12.2917C15.4165 11.6667 15.4165 8.33334 17.7082 7.70834V5.62501C17.7082 4.70454 16.962 3.95834 16.0415 3.95834Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.7085 6.45834V6.87501",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.7085 9.79166V10.2083",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.7085 13.125V13.5417",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }